import React from 'react';
import styles from './styles.module.scss';

interface ProgressBarProps {
    current?: number;
    target?: number;
    title?: string;
    currency?: string;
    hidden?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
    current = 0, 
    target = 20, 
    title = "Next payout at", 
    currency = '$',
    hidden = false
}) => {
    // If hidden, return null to not render anything
    if (hidden) {
        return null;
    }

    // Calculate progress percentage
    const progressPercentage = Math.min((current / target) * 100, 100);
    
    // Format currency values
    function formatCurrency(amount: number): string {
        return Number.isInteger(amount)
            ? `${currency}${amount}`
            : `${currency}${amount.toFixed(1)}`;
    }

    return (
        <div className={styles.progressBarContainer}>
            <div className={styles.progressBarHeader}>
                {title} {formatCurrency(target)}
            </div>
            
            <div className={styles.progressBarWrapper}>
                <div 
                    className={styles.progressBarFill}
                    style={{ width: `${progressPercentage}%` }}
                />
                <div className={styles.progressBarText}>
                    {formatCurrency(current)} / {formatCurrency(target)}
                </div>
            </div>
        </div>
    );
}

export default ProgressBar;